import React from "react"
import { Button, Spinner } from "reactstrap"

let BUTTON_SHAPE_CLASS = {
  ROUNDED: "btn-rounded",
  SQUARED: "",
}

let buttonShape = BUTTON_SHAPE_CLASS.SQUARED //switch between squared and rounded

export const SaveButton = ({
  content = "Saving...",
  type = "submit",
  onClick,
  children,
  loading,
  color = "success",
  fullWidth,
  size = "",
  disabled,
}) => {
  if (loading) {
    return (
      <Button
        type={type}
        color={color}
        className={`w-sm ${fullWidth ? "col-12" : ""} ${buttonShape}`}
        size={fullWidth ? "12" : size}
        disabled
      >
        <Spinner size={"sm"} color="light" /> {children || content}
      </Button>
    )
  }
  return (
    <Button
      disabled={disabled}
      type={type}
      onClick={onClick}
      color={color}
      className={`w-sm ${fullWidth ? "col-12" : ""} ${buttonShape}`}
      size={fullWidth ? "12" : size}
    >
      {children || content}
    </Button>
  )
}

export const ActionButton = ({
  content = "Saving...",
  type = "button",
  onClick,
  children,
  loading,
  fullWidth,
  size = "",
  disabled,
}) => {
  if (loading) {
    return (
      <Button
        style={{
          backgroundColor: "#2a3042",
        }}
        type={type}
        className={`w-sm ${fullWidth ? "col-12" : ""} ${buttonShape}`}
        size={fullWidth ? "12" : size}
        disabled
      >
        <Spinner size={"sm"} color="light" /> {children || content}
      </Button>
    )
  }
  return (
    <Button
      style={{
        backgroundColor: "#2a3042",
      }}
      disabled={disabled}
      type={type}
      onClick={onClick}
      className={`w-sm ${fullWidth ? "col-12" : ""} ${buttonShape}`}
      size={fullWidth ? "12" : size}
    >
      {children || content}
    </Button>
  )
}

export const AddButton = ({
  content = "Add",
  type = "button",
  onClick,
  children,
  color = "success",
  fullWidth,
  size = "",
}) => {
  return (
    <Button
      type={type}
      color={color}
      className={`${buttonShape} align-items-center ${fullWidth && "col-12"}`}
      onClick={onClick}
      size={fullWidth ? "12" : size}
    >
      <i className={"bx bx-plus bx-xs"}></i> {children || content}
    </Button>
  )
}

export const RemoveButton = ({
  content,
  type = "button",
  onClick,
  children,
  color = "light",
}) => {
  return (
    <Button
      type={type}
      color={color}
      className={`btn-sm ${buttonShape}`}
      onClick={onClick}
    >
      {children || content}
    </Button>
  )
}

export const SearchButton = ({
  content = "Search",
  type = "submit",
  onClick,
  children,
  color = "success",
  inline,
  fullWidth,
  size = "",
}) => {
  let buttonStyle
  if (inline) {
    buttonStyle = `w-sm ${buttonShape} mx-1 my-1 inlineFormBtn`
  } else {
    buttonStyle = `w-sm ${buttonShape} mx-1 my-1`
  }
  return (
    <Button
      size={fullWidth ? "12" : size}
      type={type}
      color={color}
      className={`${buttonStyle} ${fullWidth && "col-12"}`}
      onClick={onClick}
    >
      {children || content}
    </Button>
  )
}

export const PaginationButton = ({
  content,
  type = "button",
  onClick,
  children,
  color = "light",
  icon,
}) => {
  return (
    <Button
      type={type}
      color={color}
      className={`btn-sm ${buttonShape} d-flex align-items-center justify-content-center p-1`}
      onClick={onClick}
    >
      {icon} {children || content}
    </Button>
  )
}
